import React from "react";

import { PageLoader, Typography, Modal } from "clearsense-ui/components";

const PdfModal = ({ isOpen, onClose, isLoading, url }) => (
  <Modal
    isOpen={isOpen}
    closeButton={false}
    onClose={onClose}
    data-cy="archival-documents-view-pdf-modal"
    className="archival-reports__modal"
  >
    {isLoading ? (
      <PageLoader />
    ) : (
      <object data={url} width="100%" height="100%">
        <div className="grid h-full place-items-center">
          <p className="flex gap-1">
            Can't Preview file
            <a
              href={url}
              className="text-content-darker"
              target="_blank"
              rel="noreferrer"
              download
            >
              <Typography type="semibold">Download here</Typography>
            </a>
          </p>
        </div>
      </object>
    )}
  </Modal>
);

export default PdfModal;
